var _circle, _circle2, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.4097,
    cy: 13.5,
    r: 13.5,
    fill: "white",
    fillOpacity: 0.04
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.4097,
    cy: 13.5,
    r: 13,
    stroke: "white",
    strokeOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1597 12.5625C18.6569 12.5625 19.1339 12.76 19.4855 13.1117C19.8371 13.4633 20.0347 13.9402 20.0347 14.4375V18.1875C20.0347 18.6848 19.8371 19.1617 19.4855 19.5133C19.1339 19.865 18.6569 20.0625 18.1597 20.0625H10.6597C10.1624 20.0625 9.68547 19.865 9.33384 19.5133C8.98221 19.1617 8.78467 18.6848 8.78467 18.1875V14.4375C8.78467 13.9402 8.98221 13.4633 9.33384 13.1117C9.68547 12.76 10.1624 12.5625 10.6597 12.5625V10.6875C10.6597 9.69294 11.0548 8.73911 11.758 8.03585C12.4613 7.33259 13.4151 6.9375 14.4097 6.9375C15.4042 6.9375 16.3581 7.33259 17.0613 8.03585C17.7646 8.73911 18.1597 9.69294 18.1597 10.6875V12.5625ZM14.4097 8.1875C15.0727 8.1875 15.7086 8.45089 16.1774 8.91973C16.6463 9.38857 16.9097 10.0245 16.9097 10.6875V12.5625H11.9097V10.6875C11.9097 10.0245 12.1731 9.38857 12.6419 8.91973C13.1107 8.45089 13.7466 8.1875 14.4097 8.1875ZM18.1597 13.8125H10.6597C10.4939 13.8125 10.3349 13.8783 10.2177 13.9956C10.1005 14.1128 10.0347 14.2717 10.0347 14.4375V18.1875C10.0347 18.3533 10.1005 18.5122 10.2177 18.6294C10.3349 18.7467 10.4939 18.8125 10.6597 18.8125H18.1597C18.3254 18.8125 18.4844 18.7467 18.6016 18.6294C18.7188 18.5122 18.7847 18.3533 18.7847 18.1875V14.4375C18.7847 14.2717 18.7188 14.1128 18.6016 13.9956C18.4844 13.8783 18.3254 13.8125 18.1597 13.8125Z",
    fill: "white",
    fillOpacity: 0.55
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.6c5f368a.svg";
export { ForwardRef as ReactComponent };